// Anonyme Zählung der Cookie-Entscheidung (KA-22, Folge von #731): wie viele Besucher stimmen
// Statistik und Marketing zu? Nur Tageszähler in der Datenbank (RPC record_consent_decision),
// keine IDs, keine IP, kein User-Agent. Gezählt wird nur die erste Entscheidung eines Browsers:
// „erste“ erkennt der Aufrufer daran, dass vorher keine Einwilligung gespeichert war. Bewusst
// KEIN eigenes Merk-Flag im Browser: das wäre ein zusätzlicher Speicherzugriff ohne technische
// Notwendigkeit (§ 25 TTDSG). Der gespeicherte Consent selbst ist notwendig und reicht.
// Native App zählt nicht (kein Banner), Preview-Hosts und Bots auch nicht.

export type EinwilligungsArt = "alle" | "nur_notwendig" | "individuell";
export type Geraet = "mobil" | "desktop";

const BOT_UA = /bot|crawl|spider|slurp|headless|phantom|selenium|puppeteer|playwright|lighthouse/i;

/** Art der Entscheidung aus den gewählten Kategorien. */
export function einwilligungsArt(analytics: boolean, marketing: boolean): EinwilligungsArt {
  if (analytics && marketing) return "alle";
  if (!analytics && !marketing) return "nur_notwendig";
  return "individuell";
}

/** Grobe Geräteklasse aus der Fensterbreite (kein User-Agent). */
export function geraetAusBreite(breite: number): Geraet {
  return breite < 768 ? "mobil" : "desktop";
}

/** Darf diese Entscheidung gezählt werden? Rein, damit testbar. */
export function sollZaehlen(o: {
  vorherEntschieden: boolean;
  nativ: boolean;
  produktivHost: boolean;
  userAgent: string;
}): boolean {
  if (o.vorherEntschieden || o.nativ || !o.produktivHost) return false;
  return !BOT_UA.test(o.userAgent || "");
}

/** Feuert die Zählung im Hintergrund. Fehler bleiben still (Messung darf nie stören). */
export function zaehleErsteEntscheidung(vorherEntschieden: boolean, analytics: boolean, marketing: boolean, nativ: boolean): void {
  try {
    if (typeof window === "undefined") return;
    const host = window.location.hostname;
    const produktivHost = host === "charliescrew.com" || host.endsWith(".charliescrew.com");
    if (!sollZaehlen({ vorherEntschieden, nativ, produktivHost, userAgent: navigator.userAgent })) return;
    const args = {
      p_choice: einwilligungsArt(analytics, marketing),
      p_analytics: analytics,
      p_marketing: marketing,
      p_device: geraetAusBreite(window.innerWidth),
    };
    // Supabase-Client erst bei Bedarf laden: kein Gewicht im Startpaket der Marketing-Seiten.
    void import("@/integrations/supabase/client")
      .then(({ supabase }) => (supabase as unknown as { rpc: (fn: string, a: unknown) => Promise<unknown> }).rpc("record_consent_decision", args))
      .catch(() => { /* still */ });
  } catch {
    /* still */
  }
}
